import React from 'react';
import styled, { ThemeProvider } from 'styled-components';
// @todo next-dev: import './css/base.css'; for gatsby project
import { themeGet } from '@styled-system/theme-get';
import * as theme from './index';

export const BaseStyles = styled.div`
  font-family: ${themeGet('fonts.body')};
  color: ${themeGet('colors.black')};
  line-height: ${themeGet('lineHeights.m')};
  height: 100%;
`;

const layout = ({ children }: { children: any; }) => (
  <ThemeProvider theme={theme}>
    <BaseStyles role="main">
      {children}
    </BaseStyles>
  </ThemeProvider>
);

export default layout;
